var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfferDescIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#EFF2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.713 26.606-7.884 8.568.439-11.336 7.445 2.768Z",
    fill: "#4965A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.083 20.867 36.441 5.016c.121-.06.252.06.204.186l-9.19 23.728a.148.148 0 0 1-.185.087L4.1 21.141a.148.148 0 0 1-.017-.274Z",
    fill: "#A4B2CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.828 35.175-2.93-11.068L34.303 7.154l-10.014 11.88-6.108 6.884-2.353 9.257Z",
    fill: "#778CB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferDescIcon);
export default __webpack_public_path__ + "static/media/offer_desc_icon.fcc21716c9d809dc69bb8c0cf893a5e2.svg";
export { ForwardRef as ReactComponent };